import { Component, OnInit, ElementRef, ViewChild, Inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {LOCAL_STORAGE, WebStorageService} from 'ngx-webstorage-service';
import { CommonService } from '../services/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService, Response } from '../dataService/data.service';
import { GlobalVariable } from '../app.component';
import {NgbRatingConfig} from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { ChangeDetectionStrategy } from '@angular/compiler/src/core';

@Component({
  selector: 'app-campaign-sms-tracking',
  templateUrl: './campaign-sms-tracking.component.html',
  styleUrls: ['./campaign-sms-tracking.component.scss']
})
export class CampaignSmsTrackingComponent implements OnInit {
  private BASE_URL = GlobalVariable;
  outlet_id: String = this.storage.get('outlet_id');
  slug_value: String;
  slug_value1: String;
  slug_value2: String;
  business_logo: string;
  business_name: string;
  customer_name: string;
  feedback: string;
  replied_by: string;
  feedback_reply: string;
  campaign_content: String;
  public loading = false;

  constructor(private commonservice: CommonService,
    private HttpService: DataService,
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private router: Router,
    private route: ActivatedRoute,
    private toastrService: ToastrService, private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.loading = true;
    let res: Response;

    this.route.params.forEach(val => {
     this.slug_value1 = val.campaign_id;
     this.slug_value2 = val.contact_id;
    
    });
    const json_data = {
      'campaign_id': this.slug_value1,
      'contact_id': this.slug_value2
    };
   
    const logo_service = this.HttpService.put(this.BASE_URL.CAMPAIGN_TRACKING + '?campaign_id=' + this.slug_value1 + '&contact_id=' + this.slug_value2);
    logo_service.subscribe((data: Response) => {
      res = data;
    }, error => {
        this.toastrService.error(error.error.message);
      }, () => { 
        this.business_logo = res.data['business_details'].business_logo;
        this.business_name = res.data['business_details'].business_name;
        this.campaign_content = res.data['campaign'].campaign_content;
    });
    setTimeout(() => {
      this.loading = false;
    }, 2000);
  }


}
